import React from 'react';
import { Link } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <footer>
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-brand-name">KAYA<span>·</span>SPARSHA</div>
          <p>An authentic Ayurvedic wellness clinic and Panchakarma centre dedicated to genuine healing. Rooted in 5,000-year-old tradition. Kengeri, Bangalore.</p>
          <div className="footer-brand-sub">AYUSH REGISTERED · EST. 2026 · BANGALORE</div>
        </div>

        <div className="footer-col">
          <h5>Treatments</h5>
          <ul>
            <li><Link to="/services">Consultations</Link></li>
            <li><Link to="/treatments">Abhyanga</Link></li>
            <li><Link to="/treatments">Shirodhara</Link></li>
            <li><Link to="/treatments">Panchakarma</Link></li>
            <li><Link to="/treatments">Njavarakizhi</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Packages</h5>
          <ul>
            <li><Link to="/packages">Detox Lite</Link></li>
            <li><Link to="/packages">Back &amp; Spine</Link></li>
            <li><Link to="/packages">Stress Relief</Link></li>
            <li><Link to="/packages">Post-Delivery</Link></li>
            <li><Link to="/packages">Monthly Plan</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Visit Us</h5>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/doctor">Our Doctor</Link></li>
            <li><Link to="/enquiry">Book Now</Link></li>
            <li><Link to="/contact">Find Us</Link></li>
            <li><Link to="/admin">Staff Login</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-copy">© {new Date().getFullYear()} KayaSparsha Ayurvedic Wellness. All rights reserved.</span>
        <span className="footer-tagline">Kaya · Sparsha · Svastha</span>
        <div className="footer-socials">
          {/* WhatsApp — highlighted as primary contact */}
          <a
            className="footer-soc footer-soc-wa"
            href="https://wa.me/919606209376"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with KayaSparsha on WhatsApp"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.117 1.529 5.845L.057 23.535a.563.563 0 0 0 .691.691l5.69-1.472A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.002-1.37l-.359-.214-3.722.963.988-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.58 6.58 2.182 12 2.182S21.818 6.58 21.818 12 17.42 21.818 12 21.818z"/>
            </svg>
          </a>

          {/* Facebook */}
          <a
            className="footer-soc"
            href="https://www.facebook.com/profile.php?id=61591664874583"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="KayaSparsha on Facebook"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </a>

          {/* Instagram */}
          <a
            className="footer-soc"
            href="https://www.instagram.com/kayasparsha/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="KayaSparsha on Instagram"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <circle cx="12" cy="12" r="4"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>

          {/* LinkedIn */}
          <a
            className="footer-soc"
            href="https://www.linkedin.com/company/136074623/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="KayaSparsha on LinkedIn"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect x="2" y="9" width="4" height="12"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </a>

          {/* YouTube */}
          <a
            className="footer-soc"
            href="https://www.youtube.com/@AyurvedaWithDrShruthiShetty/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ayurveda With Dr. Shruthi Shetty on YouTube"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
              <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="var(--bg, #1a1a1a)"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
